import { Form } from '@bpmn-io/form-js'

const initFormViewer = async (el) => {
  const componentsRaw = el.getAttribute('data-components')
  const components = componentsRaw ? JSON.parse(componentsRaw) : []

  const form = new Form({
    container: el,
    debounce: false,
  })

  await form.importSchema({
    components,
    type: 'default',
  })

  await el.querySelector('.fjs-powered-by').remove()

  return form
}

export default initFormViewer
